<div class="modal-header">
  <h5 class="modal-title" i18n>Incident Data</h5>
  <button (click)="close()" type="button" class="close">
    <i class="far fa-times"></i>
  </button>
</div>

<div class="modal-body">
  <app-automation-incident-data-form [form]="form"></app-automation-incident-data-form>
</div>
<div class="modal-footer">
  <button (click)="close()" type="button" class="btn btn-light">
    <span class="far fa-times"></span>
    <span i18n>Cancel</span>
  </button>

  <button (click)="onSave(form)" [disabled]="1 | isReadonlyRole" type="button" class="btn btn-secondary-info">
    <span class="cs-icon cs-icon-save"></span>
    <span i18n>Save</span>
  </button>
</div>
